export class MediaUtils {
  static getRenderedSize(
    contains: boolean,
    cWidth: number,
    cHeight: number,
    width: number,
    height: number,
    pos: number,
  ) {
    const oRatio = width / height;
    const cRatio = cWidth / cHeight;
    let targetWidth: number;
    let targetHeight: number;
    if (contains ? oRatio > cRatio : oRatio < cRatio) {
      targetWidth = cWidth;
      targetHeight = cWidth / oRatio;
    } else {
      targetWidth = cHeight * oRatio;
      targetHeight = cHeight;
    }
    const targetLeft = (cWidth - targetWidth) * (pos / 100);
    const targetTop = (cHeight - targetHeight) * (pos / 100);

    return {
      width: targetWidth,
      height: targetHeight,
      left: targetLeft,
      top: targetTop
    };
  }

  static getImgSizeInfo(img) {
    const pos = window
      .getComputedStyle(img)
      .getPropertyValue('object-position')
      ?.split(' ');
    return MediaUtils.getRenderedSize(
      true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      parseInt(pos[0]),
    );
  }
}
